import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { ContentCopyOutlinedIcon, DeleteOutlinedIcon, EditOutlinedIcon, VisibilityOutlinedIcon } from 'tuui';
import { useNavigate } from 'hooks';
import { useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import { isMotionAd, isRssChild } from '../../config/predicates';
import ActionsCellRenderer from './ActionsCellRenderer';

const ACTIONS = {
    EDIT: 'edit',
    DUPLICATE: 'duplicate',
    PREVIEW: 'preview',
    DELETE: 'delete',
};

const getTooltipMessage = (data, action, formatMessage) => {
    const videoMessageId = isMotionAd(data) ? 'video' : null;
    const rssMessageId = isRssChild(data) ? 'rss' : null;
    const domain = videoMessageId || rssMessageId || 'general';
    const messageId = `app.campaigns.creativeReports.actions.${action}.creative.${domain}`;

    const message = formatMessage({ id: messageId });

    return message === messageId ? null : message;
};

const pass = () => {};

export const DcoCreativeActionsCellRenderer = ({ data, onPreview, context, ...rest }) => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const buttonConfigs = [
        {
            onClick: pass,
            isDisabled: true,
            dataMetricComponent: 'EditActionButton',
            icon: <EditOutlinedIcon />,
            iconLabel: 'edit',
            tooltipContent: getTooltipMessage(data, ACTIONS.EDIT, formatMessage),
        },
        {
            onClick: pass,
            isDisabled: true,
            dataMetricComponent: 'DuplicateActionButton',
            icon: <ContentCopyOutlinedIcon />,
            iconLabel: 'duplicate',
            tooltipContent: getTooltipMessage(data, ACTIONS.DUPLICATE, formatMessage),
        },
        {
            onClick: () => dispatch(onPreview(data, navigate)),
            isDisabled: false,
            dataMetricComponent: 'PreviewActionButton',
            icon: <VisibilityOutlinedIcon />,
            iconLabel: 'preview',
            tooltipContent: getTooltipMessage(data, ACTIONS.PREVIEW, formatMessage),
        },
        {
            onClick: pass,
            isDisabled: true,
            dataMetricComponent: 'DeleteActionButton',
            icon: <DeleteOutlinedIcon />,
            iconLabel: 'delete',
            tooltipContent: getTooltipMessage(data, ACTIONS.DELETE, formatMessage),
        },
    ];

    return <ActionsCellRenderer data={data} buttonConfigs={buttonConfigs} context={context} {...rest} />;
};

DcoCreativeActionsCellRenderer.propTypes = {
    data: PropTypes.object,
    onPreview: PropTypes.func,
    ...ActionsCellRenderer.propTypes,
};

export default DcoCreativeActionsCellRenderer;
